import { render, staticRenderFns } from "./PettyCash.vue?vue&type=template&id=286528ac&scoped=true"
import script from "./PettyCash.vue?vue&type=script&lang=js"
export * from "./PettyCash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286528ac",
  null
  
)

export default component.exports